export default "__VITE_ASSET__NZPGcqa2__"